/**
 * @see https://docs.ens.domains/ens-deployments
 */
export const CUSTOM_REGISTRIES: Record<string, string> = {
  '11155111': '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e', // ENS on Sepolia
}
